import {CmnComp} from "../../common/CmnComp"
import section05Styles from "./section05.module.css"

export const Section05 = () => {
	return (
		<section id="5">
			<div style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", flexWrap: "wrap"}}>
				<div style={{flex: 1, padding: "20px", minWidth: "300px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", margin: "20px"}}>
					<h2 style={{fontSize: "24px", fontWeight: "bold"}}>MYR 128 – Bazi Natal Chart & Annual Luck Cycle (命盘和流年)</h2>
					<p style={{fontSize: "16px", color: "#666", marginTop: "10px"}}>Gain insights into your personal Bazi chart and a detailed analysis of your luck cycle for the year ahead.</p>
				</div>
				<div style={{flex: 1, padding: "20px", minWidth: "300px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "20px", margin: "20px"}}>
					<h2 style={{fontSize: "24px", fontWeight: "bold"}}>MYR 228 – Bazi Natal Chart & Decade Luck Cycle (命盘和大运)</h2>
					<p style={{fontSize: "16px", color: "#666", marginTop: "10px"}}>Gain insights into your personal Bazi chart and a detailed analysis of your luck cycle for the year ahead.</p>
				</div>
			</div>
		</section>
	)
}
